import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import {version } from '../config';

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false }
  }

  logout(){
    this.setExpanded(false);
    this.props.clickLogout();
    this.props.history.push('/');
  }

  register(){
    this.props.history.push('/regisztracio');    
  }

  triggerClick = () => {
    this.setExpanded(false);
  }

  setExpanded(newState){
    this.setState({expanded: newState});
  }

  render() { 
    //let loggedIn = true;
    let isAdmin = this.props.loggedIn && JSON.parse(this.props.loggedIn).isAdmin === "1";
    //console.log("navbar",JSON.parse(this.props.loggedIn));
    return ( 
      <div className="kwizda-nav">
        <Navbar expanded={this.state.expanded} expand="lg" id="kwizda-nav-bar" >
          <Navbar.Brand>
            <Link to="/fooldal">
              <img className='kwizda3-logo' src="img/kwizda3_logok/nezzuk_szeleslogo_keretben.png" alt={"Kwizda"} title={"Kwizda v"+version}></img>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => this.setExpanded(this.state.expanded ? false : "expanded")} />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              {<Nav.Item onClick={this.triggerClick}><Link to="/fooldal">Kísérletek</Link></Nav.Item>}
              {<div className="nav-separator">|</div> } 
              {<Nav.Item onClick={this.triggerClick}><Link to="/szabalyzat">Szabályzat</Link></Nav.Item> } 
              {<div className="nav-separator">|</div>} 
              {(!this.props.loggedIn) && <Nav.Item onClick={this.triggerClick}><Link to="/bejelentkezes">Bejelentkezés</Link></Nav.Item>}
              {(!this.props.loggedIn) && <button className="kwizda-button kwizda-button-navbutton" onClick={()=>this.register()}>Regisztráció</button>}
              {(this.props.loggedIn) && <Nav.Item onClick={this.triggerClick}><Link to="/profil">Profil módosítása</Link></Nav.Item>}
              {(this.props.loggedIn && isAdmin) && <div className="nav-separator">|</div> } 
              {(this.props.loggedIn && isAdmin) && <Nav.Item onClick={this.triggerClick}><Link to="/admin">Jelentkezések listája</Link></Nav.Item>}
              {(this.props.loggedIn && isAdmin) && <div className="nav-separator">|</div> } 
              {(this.props.loggedIn && isAdmin) && <Nav.Item onClick={this.triggerClick}><Link to="/termekszerkesztes">Kísérletek szerkesztése</Link></Nav.Item>}
              {(this.props.loggedIn) && <button className="kwizda-button kwizda-button-navbutton" onClick={()=>this.logout()}>Kijelentkezés</button>}
              
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
     );
  }
}
 
export default withRouter(NavigationBar);